class KeyboardShortcutManager {
    // DOM element to attach the event handler to
    // HTML Element | string | jQuery object | POJO
    #$eventTarget;

    #selector;

    #items = [];

    #eventHandler;

    constructor(eventTarget, param2, param3) {
        if (!eventTarget || eventTarget === document) {
            this.#$eventTarget = $(document);
        } else if (eventTarget instanceof $) {
            this.#$eventTarget = eventTarget;
        } else if (_.isElement(eventTarget)) {
            this.#$eventTarget = $(eventTarget);
        } else if (_.isString(eventTarget)) {
            this.#$eventTarget = $(eventTarget);
        } else {
            throw new "KeyboardShortcutManager.#eventTarget must be either a HTML element, jQuery object, POJO or string.";
        }

        let items;
        if (typeof (param3) === "undefined") {
            items = param2;
        } else {
            this.#selector = param2;
            items = param3;
        }

        if (typeof (items) !== "undefined" && items !== null) {
            this.#init(items);
        }
    }

    #saveToArray(items) {
        if (_.isArray(items)) {
            const self = this;
            _.each(items, item => self.#items.push(item));
        } else if (items instanceof KeyboardShortcutItem) {
            this.#items.push(items);
        } else {
            throw new "'items' must be either an array of 'KeyboardShortcutItem' or an instance of 'KeyboardShortcutItem'.";
        }
    }

    #init(items) {
        this.register(items);
    }

    #convertToHtml(key) {
        switch (key) {
            case "Escape":
                return "Esc";

            case "Insert":
                return "Ins";

            case "Delete":
                return "Del";

            case "Control":
                return "Ctrl";

            case "ArrowLeft":
                return "&larr;";

            case "ArrowUp":
                return "&uarr;";

            case "ArrowRight":
                return "&rarr;";

            case "ArrowDown":
                return "&darr;";

            default:
                return key;
        }
    }

    #getKeys(item) {
        const self = this;
        let keys = [];
        if (_.isArray(item.keys)) {
            _.each(item.keys, key => keys.push(self.#convertToHtml(key)));
        } else {
            keys.push(self.#convertToHtml(item.keys));
        }

        return keys;
    }

    #injectTooltip(item, parent) {
        if (typeof (item.tooltipTarget) === "undefined" || item.tooltipTarget === null) {
            return;
        }

        let $tooltipTarget;
        let defaultTooltipOptions = {
            "html": true
        };
        if (item.tooltipTarget instanceof $) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isElement(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isString(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isPlainObject(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget.element, item.targetContainer), parent);
            defaultTooltipOptions = $.extend(defaultTooltipOptions, item.tooltipTarget.options);
        } else {
            throw new "KeyboardShortcutItem.tooltipTarget must be either a HTML element, jQuery object, POJO or string.";
        }

        let keys = this.#getKeys(item);
        keys = _.map(keys, value => `<kbd>${value}</kbd>`);
        const keyboardShortcutHtml = `<div>${app.localize("KeyboardShortcut", _.join(keys, " + "))}</div>`;

        $tooltipTarget.each(function () {
            const $this = $(this);

            if (!$this.data("keyboard-shortcut-init")) {
                const tooltipOptions = $.extend({}, defaultTooltipOptions,
                    {
                        "tooltip": "true",
                        "keyboard-shortcut-init": true
                    });

                if ($this.data("original-title")) {
                    const title = $this.data("original-title");
                    $this.data("original-title", `<div class="mb-2">${title}</div>${keyboardShortcutHtml}`);
                    $this.data("keyboard-shortcut-backup", title);
                } else if ($this.attr("title")) {
                    const title = $this.attr("title");
                    $this.attr("title", `<div class="mb-2">${title}</div>${keyboardShortcutHtml}`);
                    $this.data("keyboard-shortcut-backup", title);
                } else {
                    tooltipOptions["original-title"] = keyboardShortcutHtml;
                }

                const options = {};
                _.forOwn(tooltipOptions, (value, key) => {
                    options[`data-${key}`] = value;
                });

                $this.attr(options);
            }
        });
    }

    #removeTooltip(item, parent) {
        let $tooltipTarget;
        let defaultTooltipOptions = {};
        if (item.tooltipTarget instanceof $) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isElement(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isString(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isPlainObject(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget.element, item.targetContainer), parent);
            defaultTooltipOptions = $.extend(defaultTooltipOptions, item.tooltipTarget.options);
        } else {
            return;
        }

        $tooltipTarget.each(function () {
            const $this = $(this);

            if ($tooltipTarget.data("keyboard-shortcut-init")) {
                const tooltipOptions = $.extend({}, defaultTooltipOptions,
                    {
                        "keyboard-shortcut-init": null,
                        "keyboard-shortcut-backup": null
                    });

                const keyboardShortcutBackup = $tooltipTarget.data("keyboard-shortcut-backup");
                if (keyboardShortcutBackup) {
                    // already a tooltip before keyboard shortcut injected it with tooltip
                    $tooltipTarget.data("original-title", keyboardShortcutBackup);
                } else {
                    tooltipOptions.tooltip = null;
                    tooltipOptions["original-title"] = null;
                }

                _.forOwn(tooltipOptions, (value, key) => {
                    $tooltipTarget.removeAttr(`data-${key}`);
                });
            }
        });
    }

    #hideTooltip(item, parent) {
        let $tooltipTarget;
        if (item.tooltipTarget instanceof $) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isElement(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isString(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget, item.targetContainer), parent);
        } else if (_.isPlainObject(item.tooltipTarget)) {
            $tooltipTarget = $($(item.tooltipTarget.element, item.targetContainer), parent);
        } else {
            throw new "KeyboardShortcutItem.tooltipTarget must be either a HTML element, jQuery object, POJO or string.";
        }

        $tooltipTarget.tooltip("hide");
    }

    #registerEventHandler(items) {
        const NO_NON_MODIFIER_KEY_KEY = "";
        const modifierKeys = [
            app.consts.keyboardKey.control,
            app.consts.keyboardKey.alt,
            app.consts.keyboardKey.shift,
            app.consts.keyboardKey.meta
        ];

        // group items by modifier keys
        let ctrlGroup;
        let altGroup;
        let shiftGroup;
        let metaGroup;
        let noModifierKeyItems = {};

        function getOrCreateCtrlGroup(ctrlGroup) {
            if (typeof (ctrlGroup) === "undefined" || ctrlGroup === null) {
                ctrlGroup = { altGroup: null, shiftGroup: null, metaGroup: null, items: {} };
            }

            return ctrlGroup;
        }
        function getOrCreateAltGroup(altGroup) {
            if (typeof (altGroup) === "undefined" || altGroup === null) {
                altGroup = { shiftGroup: null, metaGroup: null, items: {} };
            }

            return altGroup;
        }
        function getOrCreateShiftGroup(shiftGroup) {
            if (typeof (shiftGroup) === "undefined" || shiftGroup === null) {
                shiftGroup = { metaGroup: null, items: {} };
            }

            return shiftGroup;
        }
        function getOrCreateMetaGroup(metaGroup) {
            if (typeof (metaGroup) === "undefined" || metaGroup === null) {
                metaGroup = { items: {} };
            }

            return metaGroup;
        }
        function isModifierKey(key) {
            return _.includes(modifierKeys, key);
        }
        function getNonModifierKey(item) {
            const nonModifierKeys = _.filter(item.keys, key => !isModifierKey(key));
            const nonModifierKey = _.first(nonModifierKeys); // only get the first non-modifier key, the rest are ignored. Multiple non-modifier keys in a keyboard shortcut is not supported.

            return typeof (nonModifierKey) !== "undefined" ? nonModifierKey.toUpperCase() : NO_NON_MODIFIER_KEY_KEY;
        }

        function performActionOnItem(item) {
            if (_.includes(item.keys, app.consts.keyboardKey.control)) {
                // group that contains CTRL, ALT, SHIFT and/or META
                ctrlGroup = getOrCreateCtrlGroup(ctrlGroup);
                if (_.includes(item.keys, app.consts.keyboardKey.alt)) {
                    // contains CTRL, ALT and possibly SHIFT and/or META modifier keys
                    ctrlGroup.altGroup = getOrCreateAltGroup(ctrlGroup.altGroup);
                    if (_.includes(item.keys, app.consts.keyboardKey.shift)) {
                        // contains CTRL, ALT, SHIFT and possibly META modifier keys
                        ctrlGroup.altGroup.shiftGroup = getOrCreateShiftGroup(ctrlGroup.altGroup.shiftGroup);
                        if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                            // contains CTRL, ALT, SHIFT and META modifier keys
                            ctrlGroup.altGroup.shiftGroup.metaGroup = getOrCreateMetaGroup(ctrlGroup.altGroup.shiftGroup.metaGroup);
                            ctrlGroup.altGroup.shiftGroup.metaGroup.items[getNonModifierKey(item)] = item;
                        } else {
                            // contains CTRL, ALT, SHIFT and not META modifier keys
                            ctrlGroup.altGroup.shiftGroup.items[getNonModifierKey(item)] = item;
                        }
                    } else if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                        // contains CTRL, ALT and META modifier keys
                        ctrlGroup.altGroup.metaGroup = getOrCreateMetaGroup(ctrlGroup.altGroup.metaGroup);
                        ctrlGroup.altGroup.metaGroup.items[getNonModifierKey(item)] = item;
                    } else {
                        // only contains CTRL, ALT and not other modifier keys
                        ctrlGroup.altGroup.items[getNonModifierKey(item)] = item;
                    }
                } else if (_.includes(item.keys, app.consts.keyboardKey.shift)) {
                    // contains CTRL, SHIFT and possibly META modifier key too
                    ctrlGroup.shiftGroup = getOrCreateShiftGroup(ctrlGroup.shiftGroup);
                    if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                        // contains CTRL, SHIFT and META modifier keys
                        ctrlGroup.shiftGroup.metaGroup = getOrCreateMetaGroup(ctrlGroup.shiftGroup.metaGroup);
                        ctrlGroup.shiftGroup.metaGroup.items[getNonModifierKey(item)] = item;
                    } else {
                        // contains CTRL, SHIFT and not META modifier keys
                        ctrlGroup.shiftGroup.items[getNonModifierKey(item)] = item;
                    }
                } else if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                    // contains CTRL and META modifier keys only
                    ctrlGroup.metaGroup = getOrCreateMetaGroup(ctrlGroup.metaGroup);
                    ctrlGroup.metaGroup.items[getNonModifierKey(item)] = item;
                } else {
                    // only contains CTRL and not other modifier keys
                    ctrlGroup.items[getNonModifierKey(item)] = item;
                }
            } else if (_.includes(item.keys, app.consts.keyboardKey.alt)) {
                // group that contains ALT, SHIFT and/or META
                altGroup = getOrCreateAltGroup(altGroup);
                if (_.includes(item.keys, app.consts.keyboardKey.shift)) {
                    // contains ALT, SHIFT and possibly META modifier key too
                    altGroup.shiftGroup = getOrCreateShiftGroup(altGroup.shiftGroup);
                    if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                        // contains ALT, SHIFT and META modifier keys
                        altGroup.shiftGroup.metaGroup = getOrCreateMetaGroup(altGroup.shiftGroup.metaGroup);
                        altGroup.shiftGroup.metaGroup.items[getNonModifierKey(item)] = item;
                    } else {
                        // contains ALT, SHIFT and not META modifier keys
                        altGroup.shiftGroup.items[getNonModifierKey(item)] = item;
                    }
                } else if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                    // contains ALT and META modifier keys only
                    altGroup.metaGroup = getOrCreateMetaGroup(altGroup.metaGroup);
                    altGroup.metaGroup.items[getNonModifierKey(item)] = item;
                } else {
                    // only contains ALT and not other modifier keys
                    altGroup.items[getNonModifierKey(item)] = item;
                }
            } else if (_.includes(item.keys, app.consts.keyboardKey.shift)) {
                // group that contains SHIFT and/or META
                shiftGroup = getOrCreateShiftGroup(shiftGroup);
                if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                    // contains SHIFT and META modifier keys only
                    shiftGroup.metaGroup = getOrCreateMetaGroup(shiftGroup.metaGroup);
                    shiftGroup.metaGroup.items[getNonModifierKey(item)] = item;
                } else if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                    // only contains SHIFT and not other modifier keys
                    shiftGroup.items[getNonModifierKey(item)] = item;
                }
            } else if (_.includes(item.keys, app.consts.keyboardKey.meta)) {
                // group that contains META
                metaGroup = getOrCreateMetaGroup(metaGroup);
                metaGroup.items[getNonModifierKey(item)] = item;
            } else {
                // group that doesn't contain any modifier keys
                const key = getNonModifierKey(item);
                if (key === NO_NON_MODIFIER_KEY_KEY) {
                    throw new "Unable to create a Keyboard Shortcut map without any keys.";
                }

                noModifierKeyItems[key] = item;
            }
        }

        if (_.isArray(items)) {
            _.each(items, performActionOnItem);
        } else if (items instanceof KeyboardShortcutItem) {
            performActionOnItem(items);
        } else {
            throw new "'items' must be either an array of 'KeyboardShortcutItem' or an instance of 'KeyboardShortcutItem'.";
        }

        const manager = this;
        this.#eventHandler = function (e) {
            const element = this;

            let item;
            if (e.ctrlKey) {
                if (typeof (ctrlGroup) === "undefined" || ctrlGroup === null) {
                    return;
                }

                // CTRL and possibly ALT, SHIFT, META modifier keys are pressed.
                if (e.altKey) {
                    if (typeof (ctrlGroup.altGroup) === "undefined" || ctrlGroup.altGroup === null) {
                        return;
                    }

                    // CTRL, ALT and possibly SHIFT, META modifier keys are pressed.
                    if (e.shiftKey) {
                        if (typeof (ctrlGroup.altGroup.shiftGroup) === "undefined" || ctrlGroup.altGroup.shiftGroup === null) {
                            return;
                        }

                        // CTRL, ALT, SHIFT and possibly META modifier keys are pressed.
                        if (e.metaKey) {
                            if (typeof (ctrlGroup.altGroup.shiftGroup.metaGroup) === "undefined" || ctrlGroup.altGroup.shiftGroup.metaGroup === null) {
                                return;
                            }

                            // CTRL, ALT, SHIFT and META modifier keys are pressed.
                            const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                            item = ctrlGroup.altGroup.shiftGroup.metaGroup.items[key];
                        } else {
                            // CTRL, ALT and SHIFT modifier keys are pressed.
                            const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                            item = ctrlGroup.altGroup.shiftGroup.items[key];
                        }
                    } else if (e.metaKey) {
                        if (typeof (ctrlGroup.altGroup.metaGroup) === "undefined" || ctrlGroup.altGroup.metaGroup === null) {
                            return;
                        }

                        // CTRL, ALT and possibly META modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = ctrlGroup.altGroup.metaGroup.items[key];
                    } else {
                        // CTRL and ALT modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = ctrlGroup.altGroup.items[key];
                    }
                } else if (e.shiftKey) {
                    if (typeof (ctrlGroup.shiftGroup) === "undefined" || ctrlGroup.shiftGroup === null) {
                        return;
                    }

                    // CTRL, SHIFT and possibly META modifier keys are pressed.
                    if (e.metaKey) {
                        if (typeof (ctrlGroup.shiftGroup.metaGroup) === "undefined" || ctrlGroup.shiftGroup.metaGroup === null) {
                            return;
                        }

                        // CTRL, SHIFT and META modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = ctrlGroup.shiftGroup.metaGroup.items[key];
                    } else {
                        // CTRL and SHIFT modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = ctrlGroup.shiftGroup.items[key];
                    }
                } else if (e.metaKey) {
                    if (typeof (ctrlGroup.metaGroup) === "undefined" || ctrlGroup.metaGroup === null) {
                        return;
                    }

                    // CTRL and META modifier keys are pressed.
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = ctrlGroup.metaGroup.items[key];
                } else {
                    // only CTRL modifer key is pressed
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = ctrlGroup.items[key];
                }
            } else if (e.altKey) {
                if (typeof (altGroup) === "undefined" || altGroup === null) {
                    return;
                }

                // ALT and possibly SHIFT, META modifier keys are pressed.
                if (e.shiftKey) {
                    if (typeof (altGroup.shiftGroup) === "undefined" || altGroup.shiftGroup === null) {
                        return;
                    }

                    // ALT, SHIFT and possibly META modifier keys are pressed.
                    if (e.metaKey) {
                        if (typeof (altGroup.shiftGroup.metaGroup) === "undefined" || altGroup.shiftGroup.metaGroup === null) {
                            return;
                        }

                        // ALT, SHIFT and META modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = altGroup.shiftGroup.metaGroup.items[key];
                    } else {
                        // ALT and SHIFT modifier keys are pressed.
                        const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                        item = altGroup.shiftGroup.items[key];
                    }
                } else if (e.metaKey) {
                    if (typeof (altGroup.metaGroup) === "undefined" || altGroup.metaGroup === null) {
                        return;
                    }

                    // ALT and possibly META modifier keys are pressed.
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = altGroup.metaGroup.items[key];
                } else {
                    // ALT modifier keys are pressed.
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = altGroup.items[key];
                }
            } else if (e.shiftKey) {
                if (typeof (shiftGroup) === "undefined" || shiftGroup === null) {
                    return;
                }

                // SHIFT and possibly META modifier keys are pressed.
                if (e.metaKey) {
                    if (typeof (shiftGroup.metaGroup) === "undefined" || shiftGroup.metaGroup === null) {
                        return;
                    }

                    // SHIFT and META modifier keys are pressed.
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = shiftGroup.metaGroup.items[key];
                } else {
                    // SHIFT modifier keys are pressed.
                    const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                    item = shiftGroup.items[key];
                }
            } else if (e.metaKey) {
                if (typeof (metaGroup) === "undefined" || metaGroup === null) {
                    return;
                }

                // META modifier keys are pressed.
                const key = isModifierKey(e.key) ? NO_NON_MODIFIER_KEY_KEY : e.key.toUpperCase();
                item = metaGroup.items[key];
            } else {
                item = noModifierKeyItems[e.key];
            }

            if (typeof (item) !== "undefined" && item !== null && typeof (item.callback) !== "undefined" && item.callback !== null) {
                let $tooltipTarget;
                if (item.tooltipTarget instanceof $) {
                    $tooltipTarget = $(item.tooltipTarget, item.targetContainer);
                } else if (_.isElement(item.tooltipTarget)) {
                    $tooltipTarget = $(item.tooltipTarget, item.targetContainer);
                } else if (_.isString(item.tooltipTarget)) {
                    $tooltipTarget = $(item.tooltipTarget, item.targetContainer);
                } else if (_.isPlainObject(item.tooltipTarget)) {
                    $tooltipTarget = $(item.tooltipTarget.element, item.targetContainer);
                } else {
                    throw new "KeyboardShortcutItem.tooltipTarget must be either a HTML element, jQuery object, POJO or string.";
                }

                const throttledCallback = app.throttle(50, item.callback);
                throttledCallback.call(element, e, $tooltipTarget, manager);
            }
        };

        if (this.#selector) {
            this.#$eventTarget.on("keydown", this.#selector, this.#eventHandler);
        } else {
            this.#$eventTarget.on("keydown", this.#eventHandler);
        }
    }

    #unregisterEventHandler() {
        if (this.#eventHandler) {
            if (this.#selector) {
                this.#$eventTarget.off("keydown", this.#selector, this.#eventHandler);
            } else {
                this.#$eventTarget.off("keydown", this.#eventHandler);
            }

            this.#eventHandler = null;
        }
    }

    register(items) {
        const self = this;
        self.#saveToArray(items);

        if (_.isArray(items)) {
            _.each(items, item => self.#injectTooltip(item));
        } else if (items instanceof KeyboardShortcutItem) {
            self.#injectTooltip(items);
        } else {
            throw new "'items' must be either an array of 'KeyboardShortcutItem' or an instance of 'KeyboardShortcutItem'.";
        }

        self.#unregisterEventHandler(); // unregister existing event handler first.
        self.#registerEventHandler(self.#items); // then re-register the event handler for unregistered and new items.
    }

    injectTooltips(parent) {
        const self = this;
        _.each(self.#items, item => self.#injectTooltip(item, parent));
    }

    hideTooltips(parent) {
        const self = this;
        _.each(self.#items, item => self.#hideTooltip(item, parent));
    }

    unregister() {
        const self = this;
        _.each(self.#items, item => self.#removeTooltip(item));
        self.#items = [];

        self.#unregisterEventHandler();
    }
}

class KeyboardShortcutItem {
    // string - the KeyboardEvent.key https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key, https://keyjs.dev/
    // Array[string] - Key combinations
    keys;

    // DOM element to inject tooltip into
    // Element | string | jQuery object | POJO
    // if POJO, contains the following properties:
    // element - Element | string | jQuery object | POJO
    // options - Bootstrap Tooltip options
    tooltipTarget;

    // the parent/container of the tooltipTarget
    // Element | string | jQuery object
    targetContainer;

    callback;

    constructor(keys, tooltipTarget, callback, targetContainer = "body") {
        this.keys = keys;
        this.tooltipTarget = tooltipTarget;
        this.callback = callback;
        this.targetContainer = targetContainer;
    }
}
